import React from 'react'

function Footer() {
  return (
    <div>
        <div className="footer" id="footer" data-bg-color="#2b2d3b" style={{}}>
  <p className="font-12 text-black-777 m-0 sm-text-center">
    Copyright ©2023 Designed &amp; Developed by{" "}
    <a href="https://sparklabitsolutions.co.in/">
      &nbsp;&nbsp;
      <span className="develop">
        <u>Sparklab IT Solutions Pvt.Ltd</u>
      </span>
    </a>
  </p>
</div>

    </div>
  )
}

export default Footer;